import classNames from 'classnames';
import styles from './Loader.module.css';

const Loader = ({ className }) => (
  <div className={classNames(styles.component, className)}>
    <img
      src={require('../../assets/images/loader.gif')}
      alt="Preloader"
      className={styles.preloader}
    />
  </div>
);

export default Loader;
